export default "__VITE_ASSET__059a250a__"